import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { ViewRotationService } from '@app/services/view-rotation.service';
import { environment } from '@environments/environment';

interface ViewEntry {
  key: string;
  label: string;
  index: number;
  enabled: boolean;
}

const VIEW_LABELS: Record<string, string> = {
  currentCustomers: 'Current Customers',
  workOrdersProgress: 'Work Orders',
  knittingOrderProgress: 'Knitting Orders',
  rejectedKnittingOrders: 'Rejected Orders',
  shiftAnnouncement: 'Shift Announcement',
  machineProductionRate: 'Lbs/h por Máquina',
  closedKnittingOrders: 'Closed Knitting Orders',
  rejectedMachines: 'Quality by Machine',
};

@Component({
  selector: 'app-dev-view-switcher',
  templateUrl: './dev-view-switcher.component.html',
  styleUrl: './dev-view-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DevViewSwitcherComponent {
  readonly rotationService = inject(ViewRotationService);
  readonly isOpen = signal<boolean>(false);

  readonly views: ViewEntry[] = Object.entries(environment.dashboard.views)
    .map(([key, v]) => ({
      key,
      label: VIEW_LABELS[key] ?? key,
      index: v.index,
      enabled: v.enabled,
    }))
    .sort((a, b) => a.index - b.index);

  readonly activeIndex = computed(() => this.rotationService.currentViewIndex());
  readonly isPaused = computed(() => this.rotationService.manualOverride() !== null);

  toggle(): void {
    this.isOpen.update(v => !v);
  }

  jumpTo(index: number): void {
    this.rotationService.jumpTo(index);
  }

  resume(): void {
    this.rotationService.resumeRotation();
  }
}
